export default "__VITE_ASSET__WJnp$AYK__"